var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9167 15.2692L12.381 10.2692M7.61913 10.2692L2.08344 15.2692M1.66675 6.10254L8.47085 10.8654C9.02182 11.2511 9.29731 11.4439 9.59697 11.5186C9.86166 11.5846 10.1385 11.5846 10.4032 11.5186C10.7029 11.4439 10.9783 11.2511 11.5293 10.8654L18.3334 6.10254M5.66675 16.9359H14.3334C15.7335 16.9359 16.4336 16.9359 16.9684 16.6634C17.4388 16.4237 17.8212 16.0413 18.0609 15.5708C18.3334 15.0361 18.3334 14.336 18.3334 12.9359V7.60254C18.3334 6.20241 18.3334 5.50234 18.0609 4.96756C17.8212 4.49716 17.4388 4.11471 16.9684 3.87502C16.4336 3.60254 15.7335 3.60254 14.3334 3.60254H5.66675C4.26662 3.60254 3.56655 3.60254 3.03177 3.87502C2.56137 4.11471 2.17892 4.49716 1.93923 4.96756C1.66675 5.50234 1.66675 6.20241 1.66675 7.60254V12.9359C1.66675 14.336 1.66675 15.0361 1.93923 15.5708C2.17892 16.0413 2.56137 16.4237 3.03177 16.6634C3.56655 16.9359 4.26662 16.9359 5.66675 16.9359Z",
    stroke: "#737373",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLogo);
export default __webpack_public_path__ + "static/media/MailLogo.f182724bb92d4c10cbaec5146a9993eb.svg";
export { ForwardRef as ReactComponent };